<svg class="svg-icon svg-icon--xl"><use [attr.href]="'assets/icons-general.svg#' + icon"></use></svg>